import { all } from 'redux-saga/effects';
import { watchCreate } from './create';

export function* watchComments() {
  yield all([watchCreate()]);
}
